<template>
    <SbsTooltip v-bind="tooltipData" class="sbs-videolayer-mute-icon" ref="muteToggle">
        <div class="sbs-videolayer-mute-icon__icon-wrapper">
            <InlineSvg class="sbs-videolayer-mute-icon__icon" :src="muteIcon" @click="handleMuteClick" />
        </div>
    </SbsTooltip>
</template>

<script>
import InlineSvg from 'vue-inline-svg';
import { toRaw } from 'vue';
import SbsTooltip from '../../tooltip/SbsTooltip.vue';
import muteIcon from '../../../assets/svg/video-mute-icon.svg';
import muteIconCross from '../../../assets/svg/video-mute-icon-cross.svg';

export default {
    name: 'SbsVideoPlayerMuteToggle',
    components: {
        SbsTooltip,
        InlineSvg,
    },
    inject: {
        videoPlayerComponent: { default: null },
    },
    data() {
        return {
            muteToggleTooltipText: 'Выключить звук',
            muteToggleComponent: null,
            muteIcon,
        };
    },
    computed: {
        player() {
            return toRaw(this.videoPlayerComponent.player);
        },
        tooltipData() {
            return {
                parentSelector: this.videoPlayerComponent.videoContainerSelector,
                offset: 0,
                position: 'top',
                content: this.muteToggleTooltipText,
            };
        },
    },
    methods: {
        setMuteToggleTooltipData() {
            const isMuted = this.player.muted() || this.player.volume() === 0;

            this.muteToggleTooltipText = isMuted ? 'Включить звук' : 'Выключить звук';
            this.muteIcon = isMuted ? muteIconCross : muteIcon;
        },
        handleMuteClick() {
            if (this.player.muted() || this.player.volume() === 0) this.player.muted(false);
            else this.player.muted(true);

            this.setMuteToggleTooltipData();
        },
    },
    mounted() {
        this.player.controlBar.addChild('Component', {
            el: this.$refs.muteToggle.$el,
        });
        this.player.on('volumechange', this.setMuteToggleTooltipData);
    },
    unmounted() {
        this.player.off('volumechange', this.setMuteToggleTooltipData);
    },
};
</script>

<style lang="scss">
@import "../styles/mixins.scss";

.sbs-videolayer-mute-icon__icon-wrapper {
    @include video-icon-wrapper;
}

.sbs-videolayer-mute-icon__icon {
    @include video-icon;
}
</style>

